export const etaTaxTypes = [
  {
    code: "T1",
    desc_en: "Value added tax",
    desc_ar: "ضريبه القيمه المضافه",
  },
  {
    code: "T2",
    desc_en: "Table tax (percentage)",
    desc_ar: "ضريبه الجدول (نسبيه)",
  },
  {
    code: "T3",
    desc_en: "Table tax (Fixed Amount)",
    desc_ar: "ضريبه الجدول (قطعيه)",
  },
  {
    code: "T4",
    desc_en: "Withholding tax (WHT)",
    desc_ar: "الخصم تحت حساب الضريبه",
  },
  {
    code: "T5",
    desc_en: "Stamping tax (percentage)",
    desc_ar: "ضريبه الدمغه (نسبيه)",
  },
  {
    code: "T6",
    desc_en: "Stamping Tax (amount)",
    desc_ar: "ضريبه الدمغه (قطعيه بمقدار ثابت )",
  },
  {
    code: "T7",
    desc_en: "Entertainment tax",
    desc_ar: "ضريبة الملاهى",
  },
  {
    code: "T8",
    desc_en: "Resource development fee",
    desc_ar: "رسم تنميه الموارد",
  },
  {
    code: "T9",
    desc_en: "Table tax (percentage)",
    desc_ar: "رسم خدمة",
  },
  {
    code: "T10",
    desc_en: "Municipality Fees",
    desc_ar: "رسم المحليات",
  },
  {
    code: "T11",
    desc_en: "Medical insurance fee",
    desc_ar: "رسم التامين الصحى",
  },
  {
    code: "T12",
    desc_en: "Other fees",
    desc_ar: "رسوم أخري",
  },
];

export const etaNonTacableTaxTypes = [
  {
    code: "T13",
    desc_en: "Stamping tax (percentage)",
    desc_ar: "ضريبه الدمغه (نسبيه)",
  },
  {
    code: "T14",
    desc_en: "Stamping Tax (amount)",
    desc_ar: "ضريبه الدمغه (قطعيه بمقدار ثابت )",
  },
  {
    code: "T15",
    desc_en: "Entertainment tax",
    desc_ar: "ضريبة الملاهى",
  },
  {
    code: "T16",
    desc_en: "Resource development fee",
    desc_ar: "رسم تنميه الموارد",
  },
  {
    code: "T17",
    desc_en: "Table tax (percentage)",
    desc_ar: "رسم خدمة",
  },
  {
    code: "T18",
    desc_en: "Municipality Fees",
    desc_ar: "رسم المحليات",
  },
  {
    code: "T19",
    desc_en: "Medical insurance fee",
    desc_ar: "رسم التامين الصحى",
  },
  {
    code: "T20",
    desc_en: "Other fees",
    desc_ar: "رسوم أخرى",
  },
];

export const etaTaxSubtypes = [
  {
    code: "V001",
    desc_en: "Export",
    desc_ar: "تصدير للخارج",
    taxtypeReference: "T1",
  },
  {
    code: "V002",
    desc_en: "Export to free areas and other areas",
    desc_ar: "تصدير مناطق حرة وأخرى",
    taxtypeReference: "T1",
  },
  {
    code: "V003",
    desc_en: "Exempted good or service",
    desc_ar: "سلعة أو خدمة معفاة",
    taxtypeReference: "T1",
  },
  {
    code: "V004",
    desc_en: "A non-taxable good or service",
    desc_ar: "سلعة أو خدمة غير خاضعة للضريبة",
    taxtypeReference: "T1",
  },
  {
    code: "V005",
    desc_en: "Exemptions for diplomats, consulates and embassies",
    desc_ar: "إعفاءات دبلوماسين والقنصليات والسفارات",
    taxtypeReference: "T1",
  },
  {
    code: "V006",
    desc_en: "Defence and National security Exemptions",
    desc_ar: "إعفاءات الدفاع والأمن القومى",
    taxtypeReference: "T1",
  },
  {
    code: "V007",
    desc_en: "Agreements exemptions",
    desc_ar: "إعفاءات اتفاقيات",
    taxtypeReference: "T1",
  },
  {
    code: "V008",
    desc_en: "Special Exemptios and other reasons",
    desc_ar: "إعفاءات خاصة و أخرى",
    taxtypeReference: "T1",
  },
  {
    code: "V009",
    desc_en: "General Item sales",
    desc_ar: "سلع عامة",
    taxtypeReference: "T1",
  },
  {
    code: "V010",
    desc_en: "Other Rates",
    desc_ar: "نسب ضريبة أخرى",
    taxtypeReference: "T1",
  },
  {
    code: "Tbl01",
    desc_en: "Table tax (percentage)",
    desc_ar: "ضريبه الجدول (نسبيه)",
    taxtypeReference: "T2",
  },
  {
    code: "Tbl02",
    desc_en: "Table tax (Fixed Amount)",
    desc_ar: "ضريبه الجدول (النوعية)",
    taxtypeReference: "T3",
  },
  {
    code: "W001",
    desc_en: "Contracting",
    desc_ar: "المقاولات",
    taxtypeReference: "T4",
  },
  {
    code: "W002",
    desc_en: "Supplies",
    desc_ar: "التوريدات",
    taxtypeReference: "T4",
  },
  {
    code: "W003",
    desc_en: "Purachases",
    desc_ar: "المشتريات",
    taxtypeReference: "T4",
  },
  {
    code: "W004",
    desc_en: "Services",
    desc_ar: "الخدمات",
    taxtypeReference: "T4",
  },
  {
    code: "W005",
    desc_en:
      "Sumspaid by the cooperative societies for car transportation to their members",
    desc_ar: "المبالغالتي تدفعها الجميعات التعاونية للنقل بالسيارات لاعضائها",
    taxtypeReference: "T4",
  },
  {
    code: "W006",
    desc_en: "Commissionagency & brokerage",
    desc_ar: "الوكالةبالعمولة والسمسرة",
    taxtypeReference: "T4",
  },
  {
    code: "W007",
    desc_en:
      "Discounts& grants & additional exceptional incentives granted by smoke &cement companies",
    desc_ar:
      "الخصوماتوالمنح والحوافز الاستثنائية ةالاضافية التي تمنحها شركات الدخان والاسمنت ",
    taxtypeReference: "T4",
  },
  {
    code: "W008",
    desc_en:
      "Alldiscounts & grants & commissions granted by petroleum &telecommunications & other companies",
    desc_ar:
      "جميعالخصومات والمنح والعمولات  التيتمنحها  شركات البترول والاتصالات ...وغيرها من الشركات المخاطبة بنظام الخصم",
    taxtypeReference: "T4",
  },
  {
    code: "W009",
    desc_en: "Supporting export subsidies",
    desc_ar: "مساندة دعم الصادرات التي يمنحها صندوق تنمية الصادرات ",
    taxtypeReference: "T4",
  },
  {
    code: "W010",
    desc_en: "Professional fees",
    desc_ar: "اتعاب مهنية",
    taxtypeReference: "T4",
  },
  {
    code: "W011",
    desc_en: "Commission & brokerage _A_57",
    desc_ar: "العمولة والسمسرة _م_57",
    taxtypeReference: "T4",
  },
  {
    code: "W012",
    desc_en: "Hospitals collecting from doctors",
    desc_ar: "تحصيل المستشفيات من الاطباء",
    taxtypeReference: "T4",
  },
  {
    code: "W013",
    desc_en: "Royalties",
    desc_ar: "الاتاوات",
    taxtypeReference: "T4",
  },
  {
    code: "W014",
    desc_en: "Customs clearance",
    desc_ar: "تخليص جمركي ",
    taxtypeReference: "T4",
  },
  {
    code: "W015",
    desc_en: "Exemption",
    desc_ar: "أعفاء",
    taxtypeReference: "T4",
  },
  {
    code: "W016",
    desc_en: "advance payments",
    desc_ar: "دفعات مقدمه",
    taxtypeReference: "T4",
  },
  {
    code: "ST01",
    desc_en: "Stamping tax (percentage)",
    desc_ar: "ضريبه الدمغه (نسبيه)",
    taxtypeReference: "T5",
  },
  {
    code: "ST02",
    desc_en: "Stamping Tax (amount)",
    desc_ar: "ضريبه الدمغه (قطعيه بمقدار ثابت)",
    taxtypeReference: "T6",
  },
  {
    code: "Ent01",
    desc_en: "Entertainment tax (rate)",
    desc_ar: "ضريبة الملاهى (نسبة)",
    taxtypeReference: "T7",
  },
  {
    code: "Ent02",
    desc_en: "Entertainment tax (amount)",
    desc_ar: "ضريبة الملاهى (قطعية)",
    taxtypeReference: "T7",
  },
  {
    code: "RD01",
    desc_en: "Resource development fee (rate)",
    desc_ar: "رسم تنميه الموارد (نسبة)",
    taxtypeReference: "T8",
  },
  {
    code: "RD02",
    desc_en: "Resource development fee (amount)",
    desc_ar: "رسم تنميه الموارد (قطعية)",
    taxtypeReference: "T8",
  },
  {
    code: "SC01",
    desc_en: "Service charges (rate)",
    desc_ar: "رسم خدمة (نسبة)",
    taxtypeReference: "T9",
  },
  {
    code: "SC02",
    desc_en: "Service charges (amount)",
    desc_ar: "رسم خدمة (قطعية)",
    taxtypeReference: "T9",
  },
  {
    code: "Mn01",
    desc_en: "Municipality Fees (rate)",
    desc_ar: "رسم المحليات (نسبة)",
    taxtypeReference: "T10",
  },
  {
    code: "Mn02",
    desc_en: "Municipality Fees (amount)",
    desc_ar: "رسم المحليات (قطعية)",
    taxtypeReference: "T10",
  },
  {
    code: "MI01",
    desc_en: "Medical insurance fee (rate)",
    desc_ar: "رسم التامين الصحى (نسبة)",
    taxtypeReference: "T11",
  },
  {
    code: "MI02",
    desc_en: "Medical insurance fee (amount)",
    desc_ar: "رسم التامين الصحى (قطعية)",
    taxtypeReference: "T11",
  },
  {
    code: "OF01",
    desc_en: "Other fees (rate)",
    desc_ar: "رسوم أخرى (نسبة)",
    taxtypeReference: "T12",
  },
  {
    code: "OF02",
    desc_en: "Other fees (amount)",
    desc_ar: "رسوم أخرى (قطعية)",
    taxtypeReference: "T12",
  },
  {
    code: "ST03",
    desc_en: "Stamping tax (percentage)",
    desc_ar: "ضريبه الدمغه (نسبيه)",
    taxtypeReference: "T13",
  },
  {
    code: "ST04",
    desc_en: "Stamping Tax (amount)",
    desc_ar: "ضريبه الدمغه (قطعيه بمقدار ثابت)",
    taxtypeReference: "T14",
  },
  {
    code: "Ent03",
    desc_en: "Entertainment tax (rate)",
    desc_ar: "ضريبة الملاهى (نسبة)",
    taxtypeReference: "T15",
  },
  {
    code: "Ent04",
    desc_en: "Entertainment tax (amount)",
    desc_ar: "ضريبة الملاهى (قطعية)",
    taxtypeReference: "T15",
  },
  {
    code: "RD03",
    desc_en: "Resource development fee (rate)",
    desc_ar: "رسم تنميه الموارد (نسبة)",
    taxtypeReference: "T16",
  },
  {
    code: "RD04",
    desc_en: "Resource development fee (amount)",
    desc_ar: "رسم تنميه الموارد (قطعية)",
    taxtypeReference: "T16",
  },
  {
    code: "SC03",
    desc_en: "Service charges (rate)",
    desc_ar: "رسم خدمة (نسبة)",
    taxtypeReference: "T17",
  },
  {
    code: "SC04",
    desc_en: "Service charges (amount)",
    desc_ar: "رسم خدمة (قطعية)",
    taxtypeReference: "T17",
  },
  {
    code: "Mn03",
    desc_en: "Municipality Fees (rate)",
    desc_ar: "رسم المحليات (نسبة)",
    taxtypeReference: "T18",
  },
  {
    code: "Mn04",
    desc_en: "Municipality Fees (amount)",
    desc_ar: "رسم المحليات (قطعية)",
    taxtypeReference: "T18",
  },
  {
    code: "MI03",
    desc_en: "Medical insurance fee (rate)",
    desc_ar: "رسم التامين الصحى (نسبة)",
    taxtypeReference: "T19",
  },
  {
    code: "MI04",
    desc_en: "Medical insurance fee (amount)",
    desc_ar: "رسم التامين الصحى (قطعية)",
    taxtypeReference: "T19",
  },
  {
    code: "OF03",
    desc_en: "Other fees (rate)",
    desc_ar: "رسوم أخرى (نسبة)",
    taxtypeReference: "T20",
  },
  {
    code: "OF04",
    desc_en: "Other fees (amount)",
    desc_ar: "رسوم أخرى (قطعية)",
    taxtypeReference: "T20",
  },
];

export const countryCodes = [
  {
    code: "AD",
    desc_en: "Andorra",
    desc_ar: "أندورا",
  },
  {
    code: "AE",
    desc_en: "United Arab Emirates",
    desc_ar: "الامارات العربية المتحدة",
  },
  {
    code: "AF",
    desc_en: "Afghanistan",
    desc_ar: "أفغانستان",
  },
  {
    code: "AG",
    desc_en: "Antigua and Barbuda",
    desc_ar: "أنتيغوا وباربودا",
  },
  {
    code: "AI",
    desc_en: "Anguilla",
    desc_ar: "أنجويلا",
  },
  {
    code: "AL",
    desc_en: "Albania",
    desc_ar: "ألبانيا",
  },
  {
    code: "AM",
    desc_en: "Armenia",
    desc_ar: "أرمينيا",
  },
  {
    code: "AO",
    desc_en: "Angola",
    desc_ar: "أنجولا",
  },
  {
    code: "AQ",
    desc_en: "Antarctica",
    desc_ar: "القارة القطبية الجنوبية",
  },
  {
    code: "AR",
    desc_en: "Argentina",
    desc_ar: "الأرجنتين",
  },
  {
    code: "AS",
    desc_en: "American Samoa",
    desc_ar: "ساموا الأمريكية",
  },
  {
    code: "AT",
    desc_en: "Austria",
    desc_ar: "النمسا",
  },
  {
    code: "AU",
    desc_en: "Australia",
    desc_ar: "أستراليا",
  },
  {
    code: "AW",
    desc_en: "Aruba",
    desc_ar: "آروبا",
  },
  {
    code: "AX",
    desc_en: "Åland Islands",
    desc_ar: "جزر أولان",
  },
  {
    code: "AZ",
    desc_en: "Azerbaijan",
    desc_ar: "أذربيجان",
  },
  {
    code: "BA",
    desc_en: "Bosnia and Herzegovina",
    desc_ar: "البوسنة والهرسك",
  },
  {
    code: "BB",
    desc_en: "Barbados",
    desc_ar: "بربادوس",
  },
  {
    code: "BD",
    desc_en: "Bangladesh",
    desc_ar: "بنجلاديش",
  },
  {
    code: "BE",
    desc_en: "Belgium",
    desc_ar: "بلجيكا",
  },
  {
    code: "BF",
    desc_en: "Burkina Faso",
    desc_ar: "بوركينا فاسو",
  },
  {
    code: "BG",
    desc_en: "Bulgaria",
    desc_ar: "بلغاريا",
  },
  {
    code: "BH",
    desc_en: "Bahrain",
    desc_ar: "البحرين",
  },
  {
    code: "BI",
    desc_en: "Burundi",
    desc_ar: "بوروندي",
  },
  {
    code: "BJ",
    desc_en: "Benin",
    desc_ar: "بنين",
  },
  {
    code: "BL",
    desc_en: "Saint Barthelemy",
    desc_ar: "سان بارتيلمي",
  },
  {
    code: "BM",
    desc_en: "Bermuda",
    desc_ar: "برمودا",
  },
  {
    code: "BN",
    desc_en: "Brunei Darussalam",
    desc_ar: "بروناي",
  },
  {
    code: "BO",
    desc_en: "Bolivia (Plurinational State of)",
    desc_ar: "بوليفيا",
  },
  {
    code: "BQ",
    desc_en: "Bonaire, Sint Eustatius and Saba",
    desc_ar: "الجزر الكاريبية الهولندية",
  },
  {
    code: "BR",
    desc_en: "Brazil",
    desc_ar: "البرازيل",
  },
  {
    code: "BS",
    desc_en: "Bahamas",
    desc_ar: "الباهاما",
  },
  {
    code: "BT",
    desc_en: "Bhutan",
    desc_ar: "بوتان",
  },
  {
    code: "BV",
    desc_en: "Bouvet Island",
    desc_ar: "جزيرة بوفيه",
  },
  {
    code: "BW",
    desc_en: "Botswana",
    desc_ar: "بتسوانا",
  },
  {
    code: "BY",
    desc_en: "Belarus",
    desc_ar: "روسيا البيضاء",
  },
  {
    code: "BZ",
    desc_en: "Belize",
    desc_ar: "بليز",
  },
  {
    code: "CA",
    desc_en: "Canada",
    desc_ar: "كندا",
  },
  {
    code: "CC",
    desc_en: "Cocos (Keeling) Islands",
    desc_ar: "جزر كوكوس",
  },
  {
    code: "CD",
    desc_en: "Congo (Democratic Republic of the)",
    desc_ar: "جمهورية الكونغو الديمقراطية",
  },
  {
    code: "CF",
    desc_en: "Central African Republic",
    desc_ar: "جمهورية أفريقيا الوسطى",
  },
  {
    code: "CG",
    desc_en: "Congo",
    desc_ar: "جمهورية الكونغو",
  },
  {
    code: "CH",
    desc_en: "Switzerland",
    desc_ar: "سويسرا",
  },
  {
    code: "CI",
    desc_en: "Cote d’Ivoire",
    desc_ar: "ساحل العاج",
  },
  {
    code: "CK",
    desc_en: "Cook Islands",
    desc_ar: "جزر كوك",
  },
  {
    code: "CL",
    desc_en: "Chile",
    desc_ar: "شيلي",
  },
  {
    code: "CM",
    desc_en: "Cameroon",
    desc_ar: "الكاميرون",
  },
  {
    code: "CN",
    desc_en: "China",
    desc_ar: "الصين",
  },
  {
    code: "CO",
    desc_en: "Colombia",
    desc_ar: "كولومبيا",
  },
  {
    code: "CR",
    desc_en: "Costa Rica",
    desc_ar: "كوستاريكا",
  },
  {
    code: "CU",
    desc_en: "Cuba",
    desc_ar: "كوبا",
  },
  {
    code: "CV",
    desc_en: "Cabo Verde",
    desc_ar: "الرأس الأخضر",
  },
  {
    code: "CW",
    desc_en: "Curaçao",
    desc_ar: "كوراساو",
  },
  {
    code: "CX",
    desc_en: "Christmas Island",
    desc_ar: "جزيرة عيد الميلاد",
  },
  {
    code: "CY",
    desc_en: "Cyprus",
    desc_ar: "قبرص",
  },
  {
    code: "CZ",
    desc_en: "Czechia",
    desc_ar: "جمهورية التشيك",
  },
  {
    code: "DE",
    desc_en: "Germany",
    desc_ar: "ألمانيا",
  },
  {
    code: "DJ",
    desc_en: "Djibouti",
    desc_ar: "جيبوتي",
  },
  {
    code: "DK",
    desc_en: "Denmark",
    desc_ar: "الدانمرك",
  },
  {
    code: "DM",
    desc_en: "Dominica",
    desc_ar: "دومينيكا",
  },
  {
    code: "DO",
    desc_en: "Dominican Republic",
    desc_ar: "جمهورية الدومينيكان",
  },
  {
    code: "DZ",
    desc_en: "Algeria",
    desc_ar: "الجزائر",
  },
  {
    code: "EC",
    desc_en: "Ecuador",
    desc_ar: "الاكوادور",
  },
  {
    code: "EE",
    desc_en: "Estonia",
    desc_ar: "استونيا",
  },
  {
    code: "EG",
    desc_en: "Egypt",
    desc_ar: "مصر",
  },
  {
    code: "EH",
    desc_en: "Western Sahara",
    desc_ar: "الصحراء الغربية",
  },
  {
    code: "ER",
    desc_en: "Eritrea",
    desc_ar: "اريتريا",
  },
  {
    code: "ES",
    desc_en: "Spain",
    desc_ar: "أسبانيا",
  },
  {
    code: "ET",
    desc_en: "Ethiopia",
    desc_ar: "اثيوبيا",
  },
  {
    code: "FI",
    desc_en: "Finland",
    desc_ar: "فنلندا",
  },
  {
    code: "FJ",
    desc_en: "Fiji",
    desc_ar: "فيجي",
  },
  {
    code: "FK",
    desc_en: "Falkland Islands (Malvinas)",
    desc_ar: "جزر فوكلاند",
  },
  {
    code: "FM",
    desc_en: "Micronesia (Federated States of)",
    desc_ar: "ميكرونيزيا",
  },
  {
    code: "FO",
    desc_en: "Faroe Islands",
    desc_ar: "جزر فارو",
  },
  {
    code: "FR",
    desc_en: "France",
    desc_ar: "فرنسا",
  },
  {
    code: "GA",
    desc_en: "Gabon",
    desc_ar: "الجابون",
  },
  {
    code: "GB",
    desc_en: "United Kingdom of Great Britain and Northern Ireland",
    desc_ar: "المملكة المتحدة",
  },
  {
    code: "GD",
    desc_en: "Grenada",
    desc_ar: "جرينادا",
  },
  {
    code: "GE",
    desc_en: "Georgia",
    desc_ar: "جورجيا",
  },
  {
    code: "GF",
    desc_en: "French Guiana",
    desc_ar: "غويانا",
  },
  {
    code: "GG",
    desc_en: "Guernsey",
    desc_ar: "جيرنزي",
  },
  {
    code: "GH",
    desc_en: "Ghana",
    desc_ar: "غانا",
  },
  {
    code: "GI",
    desc_en: "Gibraltar",
    desc_ar: "جبل طارق",
  },
  {
    code: "GL",
    desc_en: "Greenland",
    desc_ar: "جرينلاند",
  },
  {
    code: "GM",
    desc_en: "Gambia",
    desc_ar: "غامبيا",
  },
  {
    code: "GN",
    desc_en: "Guinea",
    desc_ar: "غينيا",
  },
  {
    code: "GP",
    desc_en: "Guadeloupe",
    desc_ar: "جوادلوب",
  },
  {
    code: "GQ",
    desc_en: "Equatorial Guinea",
    desc_ar: "غينيا الاستوائية",
  },
  {
    code: "GR",
    desc_en: "Greece",
    desc_ar: "اليونان",
  },
  {
    code: "GS",
    desc_en: "South Georgia and the South Sandwich Islands",
    desc_ar: "جورجيا الجنوبية وجزر ساندويتش الجنوبية",
  },
  {
    code: "GT",
    desc_en: "Guatemala",
    desc_ar: "جواتيمالا",
  },
  {
    code: "GU",
    desc_en: "Guam",
    desc_ar: "جوام",
  },
  {
    code: "GW",
    desc_en: "Guinea-Bissau",
    desc_ar: "غينيا بيساو",
  },
  {
    code: "GY",
    desc_en: "Guyana",
    desc_ar: "غيانا",
  },
  {
    code: "HK",
    desc_en: "Hong Kong",
    desc_ar: "هونغ كونغ",
  },
  {
    code: "HM",
    desc_en: "Heard Island and McDonald Islands",
    desc_ar: "جزيرة هيرد وجزر ماكدونالد",
  },
  {
    code: "HN",
    desc_en: "Honduras",
    desc_ar: "هندوراس",
  },
  {
    code: "HR",
    desc_en: "Croatia",
    desc_ar: "كرواتيا",
  },
  {
    code: "HT",
    desc_en: "Haiti",
    desc_ar: "هايتي",
  },
  {
    code: "HU",
    desc_en: "Hungary",
    desc_ar: "المجر",
  },
  {
    code: "ID",
    desc_en: "Indonesia",
    desc_ar: "اندونيسيا",
  },
  {
    code: "IE",
    desc_en: "Ireland",
    desc_ar: "أيرلندا",
  },
  {
    code: "IL",
    desc_en: "Israel",
    desc_ar: "اسرائيل",
  },
  {
    code: "IM",
    desc_en: "Isle of Man",
    desc_ar: "جزيرة مان",
  },
  {
    code: "IN",
    desc_en: "India",
    desc_ar: "الهند",
  },
  {
    code: "IO",
    desc_en: "British Indian Ocean Territory",
    desc_ar: "إقليم المحيط الهندي البريطاني",
  },
  {
    code: "IQ",
    desc_en: "Iraq",
    desc_ar: "العراق",
  },
  {
    code: "IR",
    desc_en: "Iran (Islamic Republic of)",
    desc_ar: "ايران",
  },
  {
    code: "IS",
    desc_en: "Iceland",
    desc_ar: "أيسلندا",
  },
  {
    code: "IT",
    desc_en: "Italy",
    desc_ar: "ايطاليا",
  },
  {
    code: "JE",
    desc_en: "Jersey",
    desc_ar: "جيرسي",
  },
  {
    code: "JM",
    desc_en: "Jamaica",
    desc_ar: "جامايكا",
  },
  {
    code: "JO",
    desc_en: "Jordan",
    desc_ar: "الأردن",
  },
  {
    code: "JP",
    desc_en: "Japan",
    desc_ar: "اليابان",
  },
  {
    code: "KE",
    desc_en: "Kenya",
    desc_ar: "كينيا",
  },
  {
    code: "KG",
    desc_en: "Kyrgyzstan",
    desc_ar: "قرغيزستان",
  },
  {
    code: "KH",
    desc_en: "Cambodia",
    desc_ar: "كمبوديا",
  },
  {
    code: "KI",
    desc_en: "Kiribati",
    desc_ar: "كيريباتي",
  },
  {
    code: "KM",
    desc_en: "Comoros",
    desc_ar: "جزر القمر",
  },
  {
    code: "KN",
    desc_en: "Saint Kitts and Nevis",
    desc_ar: "سانت كيتس ونيفيس",
  },
  {
    code: "KP",
    desc_en: "Korea (Democratic People’s Republic of)",
    desc_ar: "كوريا الشمالية",
  },
  {
    code: "KR",
    desc_en: "Korea (Republic of)",
    desc_ar: "كوريا الجنوبية",
  },
  {
    code: "KW",
    desc_en: "Kuwait",
    desc_ar: "الكويت",
  },
  {
    code: "KY",
    desc_en: "Cayman Islands",
    desc_ar: "جزر كايمان",
  },
  {
    code: "KZ",
    desc_en: "Kazakhstan",
    desc_ar: "كازاخستان",
  },
  {
    code: "LA",
    desc_en: "Lao People’s Democratic Republic",
    desc_ar: "لاوس",
  },
  {
    code: "LB",
    desc_en: "Lebanon",
    desc_ar: "لبنان",
  },
  {
    code: "LC",
    desc_en: "Saint Lucia",
    desc_ar: "سانت لوسيا",
  },
  {
    code: "LI",
    desc_en: "Liechtenstein",
    desc_ar: "ليختنشتاين",
  },
  {
    code: "LK",
    desc_en: "Sri Lanka",
    desc_ar: "سريلانكا",
  },
  {
    code: "LR",
    desc_en: "Liberia",
    desc_ar: "ليبيريا",
  },
  {
    code: "LS",
    desc_en: "Lesotho",
    desc_ar: "ليسوتو",
  },
  {
    code: "LT",
    desc_en: "Lithuania",
    desc_ar: "ليتوانيا",
  },
  {
    code: "LU",
    desc_en: "Luxembourg",
    desc_ar: "لوكسمبورج",
  },
  {
    code: "LV",
    desc_en: "Latvia",
    desc_ar: "لاتفيا",
  },
  {
    code: "LY",
    desc_en: "Libya",
    desc_ar: "ليبيا",
  },
  {
    code: "MA",
    desc_en: "Morocco",
    desc_ar: "المغرب",
  },
  {
    code: "MC",
    desc_en: "Monaco",
    desc_ar: "موناكو",
  },
  {
    code: "MD",
    desc_en: "Moldova (Republic of)",
    desc_ar: "مولدافيا",
  },
  {
    code: "ME",
    desc_en: "Montenegro",
    desc_ar: "الجبل الأسود",
  },
  {
    code: "MF",
    desc_en: "Saint Martin (French Part)",
    desc_ar: "تجمع سان مارتين",
  },
  {
    code: "MG",
    desc_en: "Madagascar",
    desc_ar: "مدغشقر",
  },
  {
    code: "MH",
    desc_en: "Marshall Islands",
    desc_ar: "جزر مارشال",
  },
  {
    code: "MK",
    desc_en: "North Macedonia",
    desc_ar: "مقدونيا",
  },
  {
    code: "ML",
    desc_en: "Mali",
    desc_ar: "مالي",
  },
  {
    code: "MM",
    desc_en: "Myanmar",
    desc_ar: "ميانمار",
  },
  {
    code: "MN",
    desc_en: "Mongolia",
    desc_ar: "منغوليا",
  },
  {
    code: "MO",
    desc_en: "Macao",
    desc_ar: "ماكاو",
  },
  {
    code: "MP",
    desc_en: "Northern Mariana Islands",
    desc_ar: "جزر ماريانا الشمالية",
  },
  {
    code: "MQ",
    desc_en: "Martinique",
    desc_ar: "مارتينيك",
  },
  {
    code: "MR",
    desc_en: "Mauritania",
    desc_ar: "موريتانيا",
  },
  {
    code: "MS",
    desc_en: "Montserrat",
    desc_ar: "مونتسرات",
  },
  {
    code: "MT",
    desc_en: "Malta",
    desc_ar: "مالطا",
  },
  {
    code: "MU",
    desc_en: "Mauritius",
    desc_ar: "موريشيوس",
  },
  {
    code: "MV",
    desc_en: "Maldives",
    desc_ar: "جزر المالديف",
  },
  {
    code: "MW",
    desc_en: "Malawi",
    desc_ar: "ملاوي",
  },
  {
    code: "MX",
    desc_en: "Mexico",
    desc_ar: "المكسيك",
  },
  {
    code: "MY",
    desc_en: "Malaysia",
    desc_ar: "ماليزيا",
  },
  {
    code: "MZ",
    desc_en: "Mozambique",
    desc_ar: "موزمبيق",
  },
  {
    code: "NA",
    desc_en: "Namibia",
    desc_ar: "ناميبيا",
  },
  {
    code: "NC",
    desc_en: "New Caledonia",
    desc_ar: "كاليدونيا الجديدة",
  },
  {
    code: "NE",
    desc_en: "Niger",
    desc_ar: "النيجر",
  },
  {
    code: "NF",
    desc_en: "Norfolk Island",
    desc_ar: "جزيرة نورفولك",
  },
  {
    code: "NG",
    desc_en: "Nigeria",
    desc_ar: "نيجيريا",
  },
  {
    code: "NI",
    desc_en: "Nicaragua",
    desc_ar: "نيكاراجوا",
  },
  {
    code: "NL",
    desc_en: "Netherlands",
    desc_ar: "هولندا",
  },
  {
    code: "NO",
    desc_en: "Norway",
    desc_ar: "النرويج",
  },
  {
    code: "NP",
    desc_en: "Nepal",
    desc_ar: "نيبال",
  },
  {
    code: "NR",
    desc_en: "Nauru",
    desc_ar: "نورو",
  },
  {
    code: "NU",
    desc_en: "Niue",
    desc_ar: "نيوي",
  },
  {
    code: "NZ",
    desc_en: "New Zealand",
    desc_ar: "نيوزيلاندا",
  },
  {
    code: "OM",
    desc_en: "Oman",
    desc_ar: "عمان",
  },
  {
    code: "PA",
    desc_en: "Panama",
    desc_ar: "بنما",
  },
  {
    code: "PE",
    desc_en: "Peru",
    desc_ar: "بيرو",
  },
  {
    code: "PF",
    desc_en: "French Polynesia",
    desc_ar: "بولينزيا الفرنسية",
  },
  {
    code: "PG",
    desc_en: "Papua New Guinea",
    desc_ar: "بابوا غينيا الجديدة",
  },
  {
    code: "PH",
    desc_en: "Philippines",
    desc_ar: "الفيلبين",
  },
  {
    code: "PK",
    desc_en: "Pakistan",
    desc_ar: "باكستان",
  },
  {
    code: "PL",
    desc_en: "Poland",
    desc_ar: "بولندا",
  },
  {
    code: "PM",
    desc_en: "Saint Pierre and Miquelon",
    desc_ar: "سان بيير وميكلون",
  },
  {
    code: "PN",
    desc_en: "Pitcairn",
    desc_ar: "بتكايرن",
  },
  {
    code: "PR",
    desc_en: "Puerto Rico",
    desc_ar: "بورتوريكو",
  },
  {
    code: "PS",
    desc_en: "Palestinian, State of",
    desc_ar: "فلسطين",
  },
  {
    code: "PT",
    desc_en: "Portugal",
    desc_ar: "البرتغال",
  },
  {
    code: "PW",
    desc_en: "Palau",
    desc_ar: "بالاو",
  },
  {
    code: "PY",
    desc_en: "Paraguay",
    desc_ar: "باراجواي",
  },
  {
    code: "QA",
    desc_en: "Qatar",
    desc_ar: "قطر",
  },
  {
    code: "RE",
    desc_en: "Réunion",
    desc_ar: "روينيون",
  },
  {
    code: "RO",
    desc_en: "Romania",
    desc_ar: "رومانيا",
  },
  {
    code: "RS",
    desc_en: "Serbia",
    desc_ar: "صربيا",
  },
  {
    code: "RU",
    desc_en: "Russian Federation",
    desc_ar: "روسيا",
  },
  {
    code: "RW",
    desc_en: "Rwanda",
    desc_ar: "رواندا",
  },
  {
    code: "SA",
    desc_en: "Saudi Arabia",
    desc_ar: "السعودية",
  },
  {
    code: "SB",
    desc_en: "Solomon Islands",
    desc_ar: "جزر سليمان",
  },
  {
    code: "SC",
    desc_en: "Seychelles",
    desc_ar: "سيشل",
  },
  {
    code: "SD",
    desc_en: "Sudan",
    desc_ar: "السودان",
  },
  {
    code: "SE",
    desc_en: "Sweden",
    desc_ar: "السويد",
  },
  {
    code: "SG",
    desc_en: "Singapore",
    desc_ar: "سنغافورة",
  },
  {
    code: "SH",
    desc_en: "Saint Helena, Ascension and Tristan da Cunha",
    desc_ar: "سانت هيلينا وأسينشين وتريستان دا كونا",
  },
  {
    code: "SI",
    desc_en: "Slovenia",
    desc_ar: "سلوفينيا",
  },
  {
    code: "SJ",
    desc_en: "Svalbard and Jan Mayen",
    desc_ar: "سفالبارد ويان ماين",
  },
  {
    code: "SK",
    desc_en: "Slovakia",
    desc_ar: "سلوفاكيا",
  },
  {
    code: "SL",
    desc_en: "Sierra Leone",
    desc_ar: "سيراليون",
  },
  {
    code: "SM",
    desc_en: "San Marino",
    desc_ar: "سان مارينو",
  },
  {
    code: "SN",
    desc_en: "Senegal",
    desc_ar: "السنغال",
  },
  {
    code: "SO",
    desc_en: "Somalia",
    desc_ar: "الصومال",
  },
  {
    code: "SR",
    desc_en: "Suriname",
    desc_ar: "سورينام",
  },
  {
    code: "SS",
    desc_en: "South Sudan",
    desc_ar: "جنوب السودان",
  },
  {
    code: "ST",
    desc_en: "Sao Tome and Principe",
    desc_ar: "ساو تومي وبرينسيب",
  },
  {
    code: "SV",
    desc_en: "El Salvador",
    desc_ar: "السلفادور",
  },
  {
    code: "SX",
    desc_en: "Sint Maarten (Dutch Part)",
    desc_ar: "سينت مارتن",
  },
  {
    code: "SY",
    desc_en: "Syrian Arab Republic",
    desc_ar: "سوريا",
  },
  {
    code: "SZ",
    desc_en: "Eswatini",
    desc_ar: "سوازيلاند",
  },
  {
    code: "TC",
    desc_en: "Turks and Caicos Islands",
    desc_ar: "جزر توركس وكايكوس",
  },
  {
    code: "TD",
    desc_en: "Chad",
    desc_ar: "تشاد",
  },
  {
    code: "TF",
    desc_en: "French Southern Territories",
    desc_ar: "أراض فرنسية جنوبية وأنتارتيكية",
  },
  {
    code: "TG",
    desc_en: "Togo",
    desc_ar: "توجو",
  },
  {
    code: "TH",
    desc_en: "Thailand",
    desc_ar: "تايلند",
  },
  {
    code: "TJ",
    desc_en: "Tajikistan",
    desc_ar: "طاجكستان",
  },
  {
    code: "TK",
    desc_en: "Tokelau",
    desc_ar: "توكيلو",
  },
  {
    code: "TL",
    desc_en: "Timor-Leste",
    desc_ar: "تيمور الشرقية",
  },
  {
    code: "TM",
    desc_en: "Turkmenistan",
    desc_ar: "تركمانستان",
  },
  {
    code: "TN",
    desc_en: "Tunisia",
    desc_ar: "تونس",
  },
  {
    code: "TO",
    desc_en: "Tonga",
    desc_ar: "تونجا",
  },
  {
    code: "TR",
    desc_en: "Turkey",
    desc_ar: "تركيا",
  },
  {
    code: "TT",
    desc_en: "Trinidad and Tobago",
    desc_ar: "ترينيداد وتوباغو",
  },
  {
    code: "TV",
    desc_en: "Tuvalu",
    desc_ar: "توفالو",
  },
  {
    code: "TW",
    desc_en: "Taiwan (Province of China)",
    desc_ar: "تايوان",
  },
  {
    code: "TZ",
    desc_en: "Tanzania, United Republic of",
    desc_ar: "تانزانيا",
  },
  {
    code: "UA",
    desc_en: "Ukraine",
    desc_ar: "أوكرانيا",
  },
  {
    code: "UG",
    desc_en: "Uganda",
    desc_ar: "أوغندا",
  },
  {
    code: "UM",
    desc_en: "United States Minor Outlying Islands",
    desc_ar: "جزر الولايات المتحدة الصغيرة النائية",
  },
  {
    code: "US",
    desc_en: "United States of America",
    desc_ar: "الولايات المتحدة",
  },
  {
    code: "UY",
    desc_en: "Uruguay",
    desc_ar: "أورجواي",
  },
  {
    code: "UZ",
    desc_en: "Uzbekistan",
    desc_ar: "أوزبكستان",
  },
  {
    code: "VA",
    desc_en: "Holy See",
    desc_ar: "الفاتيكان",
  },
  {
    code: "VC",
    desc_en: "Saint Vincent and the Grenadines",
    desc_ar: "سانت فينسنت والغرينادين",
  },
  {
    code: "VE",
    desc_en: "Venezuela (Bolivarian Republic of)",
    desc_ar: "فنزويلا",
  },
  {
    code: "VG",
    desc_en: "Virgin Islands (British)",
    desc_ar: "جزر العذراء البريطانية",
  },
  {
    code: "VI",
    desc_en: "Virgin Islands (U.S.)",
    desc_ar: "جزر العذراء الأمريكية",
  },
  {
    code: "VN",
    desc_en: "Viet Nam",
    desc_ar: "فيتنام",
  },
  {
    code: "VU",
    desc_en: "Vanuatu",
    desc_ar: "فانواتو",
  },
  {
    code: "WF",
    desc_en: "Wallis and Futuna",
    desc_ar: "والس وفوتونا",
  },
  {
    code: "WS",
    desc_en: "Samoa",
    desc_ar: "ساموا",
  },
  {
    code: "YE",
    desc_en: "Yemen",
    desc_ar: "اليمن",
  },
  {
    code: "YT",
    desc_en: "Mayotte",
    desc_ar: "مايوت",
  },
  {
    code: "ZA",
    desc_en: "South Africa",
    desc_ar: "جنوب أفريقيا",
  },
  {
    code: "ZM",
    desc_en: "Zambia",
    desc_ar: "زامبيا",
  },
  {
    code: "ZW",
    desc_en: "Zimbabwe",
    desc_ar: "زيمبابوي",
  },
];

export const currencyCodes = [
  {
    code: "AED",
    desc_en: "UAE Dirham",
  },
  {
    code: "AFN",
    desc_en: "Afghani",
  },
  {
    code: "ALL",
    desc_en: "Lek",
  },
  {
    code: "AMD",
    desc_en: "Armenian Dram",
  },
  {
    code: "ANG",
    desc_en: "Netherlands Antillean Guilder",
  },
  {
    code: "AOA",
    desc_en: "Kwanza",
  },
  {
    code: "ARS",
    desc_en: "Argentine Peso",
  },
  {
    code: "AUD",
    desc_en: "Australian Dollar",
  },
  {
    code: "AWG",
    desc_en: "Aruban Florin",
  },
  {
    code: "AZN",
    desc_en: "Azerbaijan Manat",
  },
  {
    code: "BAM",
    desc_en: "Convertible Mark",
  },
  {
    code: "BBD",
    desc_en: "Barbados Dollar",
  },
  {
    code: "BDT",
    desc_en: "Taka",
  },
  {
    code: "BGN",
    desc_en: "Bulgarian Lev",
  },
  {
    code: "BHD",
    desc_en: "Bahraini Dinar",
  },
  {
    code: "BIF",
    desc_en: "Burundi Franc",
  },
  {
    code: "BMD",
    desc_en: "Bermudian Dollar",
  },
  {
    code: "BND",
    desc_en: "Brunei Dollar",
  },
  {
    code: "BOB",
    desc_en: "Boliviano",
  },
  {
    code: "BOV",
    desc_en: "Mvdol",
  },
  {
    code: "BRL",
    desc_en: "Brazilian Real",
  },
  {
    code: "BSD",
    desc_en: "Bahamian Dollar",
  },
  {
    code: "BTN",
    desc_en: "Ngultrum",
  },
  {
    code: "BWP",
    desc_en: "Pula",
  },
  {
    code: "BYN",
    desc_en: "Belarusian Ruble",
  },
  {
    code: "BZD",
    desc_en: "Belize Dollar",
  },
  {
    code: "CAD",
    desc_en: "Canadian Dollar",
  },
  {
    code: "CDF",
    desc_en: "Congolese Franc",
  },
  {
    code: "CHE",
    desc_en: "WIR Euro",
  },
  {
    code: "CHF",
    desc_en: "Swiss Franc",
  },
  {
    code: "CHW",
    desc_en: "WIR Franc",
  },
  {
    code: "CLF",
    desc_en: "Unidad de Fomento",
  },
  {
    code: "CLP",
    desc_en: "Chilean Peso",
  },
  {
    code: "CNY",
    desc_en: "Yuan Renminbi",
  },
  {
    code: "COP",
    desc_en: "Colombian Peso",
  },
  {
    code: "COU",
    desc_en: "Unidad de Valor Real",
  },
  {
    code: "CRC",
    desc_en: "Costa Rican Colon",
  },
  {
    code: "CUC",
    desc_en: "Peso Convertible",
  },
  {
    code: "CUP",
    desc_en: "Cuban Peso",
  },
  {
    code: "CVE",
    desc_en: "Cabo Verde Escudo",
  },
  {
    code: "CZK",
    desc_en: "Czech Koruna",
  },
  {
    code: "DJF",
    desc_en: "Djibouti Franc",
  },
  {
    code: "DKK",
    desc_en: "Danish Krone",
  },
  {
    code: "DOP",
    desc_en: "Dominican Peso",
  },
  {
    code: "DZD",
    desc_en: "Algerian Dinar",
  },
  {
    code: "EGP",
    desc_en: "Egyptian Pound",
  },
  {
    code: "ERN",
    desc_en: "Nakfa",
  },
  {
    code: "ETB",
    desc_en: "Ethiopian Birr",
  },
  {
    code: "EUR",
    desc_en: "Euro",
  },
  {
    code: "FJD",
    desc_en: "Fiji Dollar",
  },
  {
    code: "FKP",
    desc_en: "Falkland Islands Pound",
  },
  {
    code: "GBP",
    desc_en: "Pound Sterling",
  },
  {
    code: "GEL",
    desc_en: "Lari",
  },
  {
    code: "GHS",
    desc_en: "Ghana Cedi",
  },
  {
    code: "GIP",
    desc_en: "Gibraltar Pound",
  },
  {
    code: "GMD",
    desc_en: "Dalasi",
  },
  {
    code: "GNF",
    desc_en: "Guinean Franc",
  },
  {
    code: "GTQ",
    desc_en: "Quetzal",
  },
  {
    code: "GYD",
    desc_en: "Guyana Dollar",
  },
  {
    code: "HKD",
    desc_en: "Hong Kong Dollar",
  },
  {
    code: "HNL",
    desc_en: "Lempira",
  },
  {
    code: "HRK",
    desc_en: "Kuna",
  },
  {
    code: "HTG",
    desc_en: "Gourde",
  },
  {
    code: "HUF",
    desc_en: "Forint",
  },
  {
    code: "IDR",
    desc_en: "Rupiah",
  },
  {
    code: "ILS",
    desc_en: "New Israeli Sheqel",
  },
  {
    code: "INR",
    desc_en: "Indian Rupee",
  },
  {
    code: "IQD",
    desc_en: "Iraqi Dinar",
  },
  {
    code: "IRR",
    desc_en: "Iranian Rial",
  },
  {
    code: "ISK",
    desc_en: "Iceland Krona",
  },
  {
    code: "JMD",
    desc_en: "Jamaican Dollar",
  },
  {
    code: "JOD",
    desc_en: "Jordanian Dinar",
  },
  {
    code: "JPY",
    desc_en: "Yen",
  },
  {
    code: "KES",
    desc_en: "Kenyan Shilling",
  },
  {
    code: "KGS",
    desc_en: "Som",
  },
  {
    code: "KHR",
    desc_en: "Riel",
  },
  {
    code: "KMF",
    desc_en: "Comorian Franc ",
  },
  {
    code: "KPW",
    desc_en: "North Korean Won",
  },
  {
    code: "KRW",
    desc_en: "Won",
  },
  {
    code: "KWD",
    desc_en: "Kuwaiti Dinar",
  },
  {
    code: "KYD",
    desc_en: "Cayman Islands Dollar",
  },
  {
    code: "KZT",
    desc_en: "Tenge",
  },
  {
    code: "LAK",
    desc_en: "Lao Kip",
  },
  {
    code: "LBP",
    desc_en: "Lebanese Pound",
  },
  {
    code: "LKR",
    desc_en: "Sri Lanka Rupee",
  },
  {
    code: "LRD",
    desc_en: "Liberian Dollar",
  },
  {
    code: "LSL",
    desc_en: "Loti",
  },
  {
    code: "LYD",
    desc_en: "Libyan Dinar",
  },
  {
    code: "MAD",
    desc_en: "Moroccan Dirham",
  },
  {
    code: "MDL",
    desc_en: "Moldovan Leu",
  },
  {
    code: "MGA",
    desc_en: "Malagasy Ariary",
  },
  {
    code: "MKD",
    desc_en: "Denar",
  },
  {
    code: "MMK",
    desc_en: "Kyat",
  },
  {
    code: "MNT",
    desc_en: "Tugrik",
  },
  {
    code: "MOP",
    desc_en: "Pataca",
  },
  {
    code: "MRU",
    desc_en: "Ouguiya",
  },
  {
    code: "MUR",
    desc_en: "Mauritius Rupee",
  },
  {
    code: "MVR",
    desc_en: "Rufiyaa",
  },
  {
    code: "MWK",
    desc_en: "Malawi Kwacha",
  },
  {
    code: "MXN",
    desc_en: "Mexican Peso",
  },
  {
    code: "MXV",
    desc_en: "Mexican Unidad de Inversion (UDI)",
  },
  {
    code: "MYR",
    desc_en: "Malaysian Ringgit",
  },
  {
    code: "MZN",
    desc_en: "Mozambique Metical",
  },
  {
    code: "NAD",
    desc_en: "Namibia Dollar",
  },
  {
    code: "NGN",
    desc_en: "Naira",
  },
  {
    code: "NIO",
    desc_en: "Cordoba Oro",
  },
  {
    code: "NOK",
    desc_en: "Norwegian Krone",
  },
  {
    code: "NPR",
    desc_en: "Nepalese Rupee",
  },
  {
    code: "NZD",
    desc_en: "New Zealand Dollar",
  },
  {
    code: "OMR",
    desc_en: "Rial Omani",
  },
  {
    code: "PAB",
    desc_en: "Balboa",
  },
  {
    code: "PEN",
    desc_en: "Sol",
  },
  {
    code: "PGK",
    desc_en: "Kina",
  },
  {
    code: "PHP",
    desc_en: "Philippine Peso",
  },
  {
    code: "PKR",
    desc_en: "Pakistan Rupee",
  },
  {
    code: "PLN",
    desc_en: "Zloty",
  },
  {
    code: "PYG",
    desc_en: "Guarani",
  },
  {
    code: "QAR",
    desc_en: "Qatari Rial",
  },
  {
    code: "RON",
    desc_en: "Romanian Leu",
  },
  {
    code: "RSD",
    desc_en: "Serbian Dinar",
  },
  {
    code: "RUB",
    desc_en: "Russian Ruble",
  },
  {
    code: "RWF",
    desc_en: "Rwanda Franc",
  },
  {
    code: "SAR",
    desc_en: "Saudi Riyal",
  },
  {
    code: "SBD",
    desc_en: "Solomon Islands Dollar",
  },
  {
    code: "SCR",
    desc_en: "Seychelles Rupee",
  },
  {
    code: "SDG",
    desc_en: "Sudanese Pound",
  },
  {
    code: "SEK",
    desc_en: "Swedish Krona",
  },
  {
    code: "SGD",
    desc_en: "Singapore Dollar",
  },
  {
    code: "SHP",
    desc_en: "Saint Helena Pound",
  },
  {
    code: "SLL",
    desc_en: "Leone",
  },
  {
    code: "SOS",
    desc_en: "Somali Shilling",
  },
  {
    code: "SRD",
    desc_en: "Surinam Dollar",
  },
  {
    code: "SSP",
    desc_en: "South Sudanese Pound",
  },
  {
    code: "STN",
    desc_en: "Dobra",
  },
  {
    code: "SVC",
    desc_en: "El Salvador Colon",
  },
  {
    code: "SYP",
    desc_en: "Syrian Pound",
  },
  {
    code: "SZL",
    desc_en: "Lilangeni",
  },
  {
    code: "THB",
    desc_en: "Baht",
  },
  {
    code: "TJS",
    desc_en: "Somoni",
  },
  {
    code: "TMT",
    desc_en: "Turkmenistan New Manat",
  },
  {
    code: "TND",
    desc_en: "Tunisian Dinar",
  },
  {
    code: "TOP",
    desc_en: "Pa’anga",
  },
  {
    code: "TRY",
    desc_en: "Turkish Lira",
  },
  {
    code: "TTD",
    desc_en: "Trinidad and Tobago Dollar",
  },
  {
    code: "TWD",
    desc_en: "New Taiwan Dollar",
  },
  {
    code: "TZS",
    desc_en: "Tanzanian Shilling",
  },
  {
    code: "UAH",
    desc_en: "Hryvnia",
  },
  {
    code: "UGX",
    desc_en: "Uganda Shilling",
  },
  {
    code: "USD",
    desc_en: "US Dollar",
  },
  {
    code: "USN",
    desc_en: "US Dollar (Next day)",
  },
  {
    code: "UYI",
    desc_en: "Uruguay Peso en Unidades Indexadas (UI)",
  },
  {
    code: "UYU",
    desc_en: "Peso Uruguayo",
  },
  {
    code: "UYW",
    desc_en: "Unidad Previsional",
  },
  {
    code: "UZS",
    desc_en: "Uzbekistan Sum",
  },
  {
    code: "VED",
    desc_en: "Bolívar Soberano",
  },
  {
    code: "VES",
    desc_en: "Bolívar Soberano",
  },
  {
    code: "VND",
    desc_en: "Dong",
  },
  {
    code: "VUV",
    desc_en: "Vatu",
  },
  {
    code: "WST",
    desc_en: "Tala",
  },
  {
    code: "XAF",
    desc_en: "CFA Franc BEAC",
  },
  {
    code: "XAG",
    desc_en: "Silver",
  },
  {
    code: "XAU",
    desc_en: "Gold",
  },
  {
    code: "XBA",
    desc_en: "Bond Markets Unit European Composite Unit (EURCO)",
  },
  {
    code: "XBB",
    desc_en: "Bond Markets Unit European Monetary Unit (E.M.U.-6)",
  },
  {
    code: "XBC",
    desc_en: "Bond Markets Unit European Unit of Account 9 (E.U.A.-9)",
  },
  {
    code: "XBD",
    desc_en: "Bond Markets Unit European Unit of Account 17 (E.U.A.-17)",
  },
  {
    code: "XCD",
    desc_en: "East Caribbean Dollar",
  },
  {
    code: "XDR",
    desc_en: "SDR (Special Drawing Right)",
  },
  {
    code: "XOF",
    desc_en: "CFA Franc BCEAO",
  },
  {
    code: "XPD",
    desc_en: "Palladium",
  },
  {
    code: "XPF",
    desc_en: "CFP Franc",
  },
  {
    code: "XPT",
    desc_en: "Platinum",
  },
  {
    code: "XSU",
    desc_en: "Sucre",
  },
  {
    code: "XTS",
    desc_en: "codes specifically reserved for testing purposes",
  },
  {
    code: "XUA",
    desc_en: "ADB Unit of Account",
  },
  {
    code: "XXX",
    desc_en:
      "The codes assigned for transactions where no currency is involved",
  },
  {
    code: "YER",
    desc_en: "Yemeni Rial",
  },
  {
    code: "ZAR",
    desc_en: "Rand",
  },
  {
    code: "ZMW",
    desc_en: "Zambian Kwacha",
  },
  {
    code: "ZWL",
    desc_en: "Zimbabwe Dollar",
  },
];

export const unitTypes = [
  {
    code: "2Z",
    desc_en: "Millivolt ( mV )",
    desc_ar: "",
  },
  {
    code: "4K",
    desc_en: "Milliampere ( mA )",
    desc_ar: "",
  },
  {
    code: "4O",
    desc_en: "Microfarad ( microF )",
    desc_ar: "",
  },
  {
    code: "A87",
    desc_en: "Gigaohm ( GOhm )",
    desc_ar: "",
  },
  {
    code: "A93",
    desc_en: "Gram/Cubic meter ( g/m3 )",
    desc_ar: "",
  },
  {
    code: "A94",
    desc_en: "Gram/cubic centimeter ( g/cm3 )",
    desc_ar: "",
  },
  {
    code: "AMP",
    desc_en: "Ampere ( A )",
    desc_ar: "",
  },
  {
    code: "ANN",
    desc_en: "Years ( yr )",
    desc_ar: "",
  },
  {
    code: "B22",
    desc_en: "Kiloampere ( kA )",
    desc_ar: "",
  },
  {
    code: "B49",
    desc_en: "Kiloohm ( kOhm )",
    desc_ar: "",
  },
  {
    code: "B75",
    desc_en: "Megohm ( MOhm )",
    desc_ar: "",
  },
  {
    code: "B78",
    desc_en: "Megavolt ( MV )",
    desc_ar: "",
  },
  {
    code: "B84",
    desc_en: "Microampere ( microA )",
    desc_ar: "",
  },
  {
    code: "BAR",
    desc_en: "bar ( bar )",
    desc_ar: "",
  },
  {
    code: "BBL",
    desc_en: "Barrel (oil 42 gal.)",
    desc_ar: "برميل",
  },
  {
    code: "BG",
    desc_en: "Bag ( Bag )",
    desc_ar: "",
  },
  {
    code: "BO",
    desc_en: "Bottle ( Bt. )",
    desc_ar: "",
  },
  {
    code: "BOX",
    desc_en: "Box",
    desc_ar: "صندوق",
  },
  {
    code: "C10",
    desc_en: "Millifarad ( mF )",
    desc_ar: "",
  },
  {
    code: "C39",
    desc_en: "Nanoampere ( nA )",
    desc_ar: "",
  },
  {
    code: "C41",
    desc_en: "Nanofarad ( nF )",
    desc_ar: "",
  },
  {
    code: "C45",
    desc_en: "Nanometer ( nm )",
    desc_ar: "",
  },
  {
    code: "C62",
    desc_en: "Activity unit ( AU )",
    desc_ar: "",
  },
  {
    code: "CA",
    desc_en: "Canister ( Can )",
    desc_ar: "",
  },
  {
    code: "CMK",
    desc_en: "Square centimeter ( cm2 )",
    desc_ar: "",
  },
  {
    code: "CMQ",
    desc_en: "Cubic centimeter ( cm3 )",
    desc_ar: "",
  },
  {
    code: "CMT",
    desc_en: "Centimeter ( cm )",
    desc_ar: "",
  },
  {
    code: "CS",
    desc_en: "Case ( Case )",
    desc_ar: "",
  },
  {
    code: "CT",
    desc_en: "Carton ( Car )",
    desc_ar: "",
  },
  {
    code: "CTL",
    desc_en: "Centiliter ( Cl )",
    desc_ar: "",
  },
  {
    code: "D10",
    desc_en: "Siemens per meter ( S/m )",
    desc_ar: "",
  },
  {
    code: "D33",
    desc_en: "Tesla ( D )",
    desc_ar: "",
  },
  {
    code: "D41",
    desc_en: "Ton/Cubic meter ( t/m3 )",
    desc_ar: "",
  },
  {
    code: "DAY",
    desc_en: "Days ( d )",
    desc_ar: "",
  },
  {
    code: "DMT",
    desc_en: "Decimeter ( dm )",
    desc_ar: "",
  },
  {
    code: "DRM",
    desc_en: "DRUM",
    desc_ar: "أسطوانة",
  },
  {
    code: "EA",
    desc_en: "each (ST) ( ST )",
    desc_ar: "",
  },
  {
    code: "FAR",
    desc_en: "Farad ( F )",
    desc_ar: "",
  },
  {
    code: "FOT",
    desc_en: "Foot ( Foot )",
    desc_ar: "",
  },
  {
    code: "FTK",
    desc_en: "Square foot ( ft2 )",
    desc_ar: "",
  },
  {
    code: "FTQ",
    desc_en: "Cubic foot ( ft3 )",
    desc_ar: "",
  },
  {
    code: "G42",
    desc_en: "Microsiemens per centimeter ( microS/cm )",
    desc_ar: "",
  },
  {
    code: "GL",
    desc_en: "Gram/liter ( g/l )",
    desc_ar: "",
  },
  {
    code: "GLL",
    desc_en: "gallon ( gal )",
    desc_ar: "",
  },
  {
    code: "GM",
    desc_en: "Gram/square meter ( g/m2 )",
    desc_ar: "",
  },
  {
    code: "GPT",
    desc_en: "Gallon per thousand",
    desc_ar: "جالون/الف",
  },
  {
    code: "GRM",
    desc_en: "Gram ( g )",
    desc_ar: "",
  },
  {
    code: "H63",
    desc_en: "Milligram/Square centimeter ( mg/cm2 )",
    desc_ar: "",
  },
  {
    code: "HHP",
    desc_en: "Hydraulic Horse Power",
    desc_ar: "قوة حصان هيدروليكي",
  },
  {
    code: "HLT",
    desc_en: "Hectoliter ( hl )",
    desc_ar: "",
  },
  {
    code: "HTZ",
    desc_en: "Hertz (1/second) ( Hz )",
    desc_ar: "",
  },
  {
    code: "HUR",
    desc_en: "Hours ( hrs )",
    desc_ar: "",
  },
  {
    code: "IE",
    desc_en: "Number of Persons ( PRS )",
    desc_ar: "",
  },
  {
    code: "INH",
    desc_en: "Inch ( “” )",
    desc_ar: "",
  },
  {
    code: "INK",
    desc_en: "Square inch ( Inch2 )",
    desc_ar: "",
  },
  {
    code: "JOB",
    desc_en: "JOB",
    desc_ar: "وظيفة",
  },
  {
    code: "KGM",
    desc_en: "Kilogram ( KG )",
    desc_ar: "",
  },
  {
    code: "KHZ",
    desc_en: "Kilohertz ( kHz )",
    desc_ar: "",
  },
  {
    code: "KMH",
    desc_en: "Kilometer/hour ( km/h )",
    desc_ar: "",
  },
  {
    code: "KMK",
    desc_en: "Square kilometer ( km2 )",
    desc_ar: "",
  },
  {
    code: "KMQ",
    desc_en: "Kilogram/cubic meter ( kg/m3 )",
    desc_ar: "",
  },
  {
    code: "KMT",
    desc_en: "Kilometer ( km )",
    desc_ar: "",
  },
  {
    code: "KSM",
    desc_en: "Kilogram/Square meter ( kg/m2 )",
    desc_ar: "",
  },
  {
    code: "KVT",
    desc_en: "Kilovolt ( kV )",
    desc_ar: "",
  },
  {
    code: "KWT",
    desc_en: "Kilowatt ( KW )",
    desc_ar: "",
  },
  {
    code: "LB",
    desc_en: "pounds ",
    desc_ar: "رطل",
  },
  {
    code: "LTR",
    desc_en: "Liter ( l )",
    desc_ar: "",
  },
  {
    code: "LVL",
    desc_en: "Level",
    desc_ar: "مستوي",
  },
  {
    code: "M",
    desc_en: "Meter ( m )",
    desc_ar: "",
  },
  {
    code: "MAN",
    desc_en: "Man",
    desc_ar: "رجل",
  },
  {
    code: "MAW",
    desc_en: "Megawatt ( VA )",
    desc_ar: "",
  },
  {
    code: "MGM",
    desc_en: "Milligram ( mg )",
    desc_ar: "",
  },
  {
    code: "MHZ",
    desc_en: "Megahertz ( MHz )",
    desc_ar: "",
  },
  {
    code: "MIN",
    desc_en: "Minute ( min )",
    desc_ar: "",
  },
  {
    code: "MMK",
    desc_en: "Square millimeter ( mm2 )",
    desc_ar: "",
  },
  {
    code: "MMQ",
    desc_en: "Cubic millimeter ( mm3 )",
    desc_ar: "",
  },
  {
    code: "MMT",
    desc_en: "Millimeter ( mm )",
    desc_ar: "",
  },
  {
    code: "MON",
    desc_en: "Months ( Months )",
    desc_ar: "",
  },
  {
    code: "MTK",
    desc_en: "Square meter ( m2 )",
    desc_ar: "",
  },
  {
    code: "MTQ",
    desc_en: "Cubic meter ( m3 )",
    desc_ar: "",
  },
  {
    code: "OHM",
    desc_en: "Ohm ( Ohm )",
    desc_ar: "",
  },
  {
    code: "ONZ",
    desc_en: "Ounce ( oz )",
    desc_ar: "",
  },
  {
    code: "PAL",
    desc_en: "Pascal ( Pa )",
    desc_ar: "",
  },
  {
    code: "PF",
    desc_en: "Pallet ( PAL )",
    desc_ar: "",
  },
  {
    code: "PK",
    desc_en: "Pack ( PAK )",
    desc_ar: "",
  },
  {
    code: "SK",
    desc_en: "Sack",
    desc_ar: "كيس",
  },
  {
    code: "SMI",
    desc_en: "Mile ( mile )",
    desc_ar: "",
  },
  {
    code: "ST",
    desc_en: "Ton (short,2000 lb)",
    desc_ar: "طن (قصير,2000)",
  },
  {
    code: "TNE",
    desc_en: "Tonne ( t )",
    desc_ar: "",
  },
  {
    code: "TON",
    desc_en: "Ton (metric)",
    desc_ar: "طن (متري)",
  },
  {
    code: "VLT",
    desc_en: "Volt ( V )",
    desc_ar: "",
  },
  {
    code: "WEE",
    desc_en: "Weeks ( Weeks )",
    desc_ar: "",
  },
  {
    code: "WTT",
    desc_en: "Watt ( W )",
    desc_ar: "",
  },
  {
    code: "X03",
    desc_en: "Meter/Hour ( m/h )",
    desc_ar: "",
  },
  {
    code: "YDQ",
    desc_en: "Cubic yard ( yd3 )",
    desc_ar: "",
  },
  {
    code: "YRD",
    desc_en: "Yards ( yd )",
    desc_ar: "",
  },
  {
    code: "NMP",
    desc_en: "Number of packs",
    desc_ar: "",
  },
  {
    code: "ST",
    desc_en: "Sheet",
    desc_ar: "",
  },
  {
    code: "5I",
    desc_en: "Standard cubic foot",
    desc_ar: "",
  },
  {
    code: "AE",
    desc_en: "Ampere per metre",
    desc_ar: "",
  },
  {
    code: "B4",
    desc_en: "Barrel, Imperial",
    desc_ar: "",
  },
  {
    code: "BB",
    desc_en: "Base box",
    desc_ar: "",
  },
  {
    code: "BD",
    desc_en: "Board",
    desc_ar: "",
  },
  {
    code: "BE",
    desc_en: "Bundle",
    desc_ar: "",
  },
  {
    code: "BK",
    desc_en: "Basket",
    desc_ar: "",
  },
  {
    code: "BL",
    desc_en: "Bale",
    desc_ar: "",
  },
  {
    code: "CH",
    desc_en: "Container",
    desc_ar: "",
  },
  {
    code: "CR",
    desc_en: "Crate",
    desc_ar: "",
  },
  {
    code: "DAA",
    desc_en: "Decare",
    desc_ar: "",
  },
  {
    code: "DTN",
    desc_en: "Decitonne",
    desc_ar: "",
  },
  {
    code: "DZN",
    desc_en: "Dozen",
    desc_ar: "",
  },
  {
    code: "FP",
    desc_en: "Pound per square foot",
    desc_ar: "",
  },
  {
    code: "HMT",
    desc_en: "Hectometre",
    desc_ar: "",
  },
  {
    code: "INQ",
    desc_en: "Cubic inch",
    desc_ar: "",
  },
  {
    code: "KG",
    desc_en: "Keg",
    desc_ar: "",
  },
  {
    code: "KTM",
    desc_en: "Kilometre",
    desc_ar: "",
  },
  {
    code: "LO",
    desc_en: "Lot [unit of procurement]",
    desc_ar: "",
  },
  {
    code: "MLT",
    desc_en: "Millilitre",
    desc_ar: "",
  },
  {
    code: "MT",
    desc_en: "Mat",
    desc_ar: "",
  },
  {
    code: "NA",
    desc_en: "Milligram per kilogram",
    desc_ar: "",
  },
  {
    code: "NAR",
    desc_en: "Number of articles",
    desc_ar: "",
  },
  {
    code: "NC",
    desc_en: "Car",
    desc_ar: "",
  },
  {
    code: "NE",
    desc_en: "Net litre",
    desc_ar: "",
  },
  {
    code: "NPL",
    desc_en: "Number of parcels",
    desc_ar: "",
  },
  {
    code: "NV",
    desc_en: "Vehicle",
    desc_ar: "",
  },
  {
    code: "PA",
    desc_en: "Packet",
    desc_ar: "",
  },
  {
    code: "PG",
    desc_en: "Plate",
    desc_ar: "",
  },
  {
    code: "PL",
    desc_en: "Pail",
    desc_ar: "",
  },
  {
    code: "PR",
    desc_en: "Pair",
    desc_ar: "",
  },
  {
    code: "PT",
    desc_en: "Pint (US)",
    desc_ar: "",
  },
  {
    code: "RL",
    desc_en: "Reel",
    desc_ar: "",
  },
  {
    code: "RO",
    desc_en: "Roll",
    desc_ar: "",
  },
  {
    code: "SET",
    desc_en: "Set",
    desc_ar: "",
  },
  {
    code: "STK",
    desc_en: "Stick, Cigarette ",
    desc_ar: "",
  },
  {
    code: "T3",
    desc_en: "Thousand piece",
    desc_ar: "",
  },
  {
    code: "TC",
    desc_en: "Truckload",
    desc_ar: "",
  },
  {
    code: "TK",
    desc_en: "Tank, rectangular",
    desc_ar: "",
  },
  {
    code: "TN",
    desc_en: "Tin",
    desc_ar: "",
  },
  {
    code: "TTS",
    desc_en: "Ten thousand sticks",
    desc_ar: "",
  },
  {
    code: "UC",
    desc_en: "Telecommunication port ",
    desc_ar: "",
  },
  {
    code: "VI",
    desc_en: "Vial",
    desc_ar: "",
  },
  {
    code: "VQ",
    desc_en: "Bulk",
    desc_ar: "",
  },
  {
    code: "YDK",
    desc_en: "Square yard",
    desc_ar: "",
  },
  {
    code: "Z3",
    desc_en: "Cask",
    desc_ar: "",
  },
];



//////////////////
// WEBPACK FOOTER
// ./src/assets/eta-taxes-info.js
// module id = ./src/assets/eta-taxes-info.js
// module chunks = main